<template>
    <!-- 储值规则设置 -->
    <content-view>
        <a-spin :spinning="loading">
            <div class="wrap-container-in stored-value-config">
                <a-form :form="form">
                    <div class="block-title">会员储值规则设置</div>
                    <a-form-item v-bind="formItemLayout" label="储值是否支持退款">
                        <a-radio defaultChecked>否</a-radio>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="储值是否支持提现">
                        <a-radio defaultChecked>否</a-radio>
                    </a-form-item>
                    <a-form-item v-bind="formItemLayout" label="储值的可消费途径">
                        <div class="flex flex-start">
                            <a-form-item>
                                <a-checkbox v-decorator="['isTicketConsume', {valuePropName: 'checked', initialValue: false}]">票券</a-checkbox>
                            </a-form-item>
                            <a-form-item>
                                <a-checkbox v-decorator="['isCourseConsume', {valuePropName: 'checked', initialValue: false}]">课程</a-checkbox>
                            </a-form-item>
                            <a-form-item>
                                <a-checkbox v-decorator="['isRetailConsume', {valuePropName: 'checked', initialValue: false}]">零售商品</a-checkbox>
                            </a-form-item>
                            <a-form-item>
                                <a-checkbox v-decorator="['isMealConsume', {valuePropName: 'checked', initialValue: false}]">餐饮</a-checkbox>
                            </a-form-item>
                        </div>
                    </a-form-item>
                    <div class="line"></div>
                    <div class="block-title">会员储值短信发送设置</div>
                    <a-form-item v-bind="formItemLayout" label="储值是否发送短信通知">
                        <a-radio defaultChecked>是</a-radio>
                    </a-form-item>
                    <div class="line"></div>
                    <div class="block-title">储值的资金安全</div>
                    <p class="in_title mb8">
                        <a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>
                        为保证用户资金安全，使用储值支付时建议验证支付密码
                    </p>
                    <a-form-item v-bind="formItemLayout" label="是否支持免密支付">
                        <a-radio defaultChecked>是</a-radio>
                    </a-form-item>
                    <div class="line"></div>
                    <a-row class="text-center mt24">
                        <a-button @click="$router.back();" :loading="loading">取消</a-button>
                        <a-button type="primary" @click="handleSubmit" :loading="loading">保存</a-button>
                    </a-row>
                </a-form>
            </div>
        </a-spin>
    </content-view>
</template>

<script type="text/javascript">
    export default {
        name: "storedValueConfig",
        zn: '储值规则配置',
        components: {
        },
        props: {},
        data() {
            return {
                formItemLayout: {
                    labelCol: {
                        sm: { span: 4 }
                    },
                    wrapperCol: {
                        sm: { span: 20 }
                    }
                },
                loading: false
            };
        },
        computed: {},
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            // 获取储值配置
            getStoredConfigDetail() {
                this.loading = true;
                this.$api.totalPlatform.storedConfigDetail().then(res => {
                    delete res.startTime;
                    delete res.endTime;
                    this.$nextTick(() => {
                        this.form.setFieldsValue(res);
                        this.loading = false;
                    })
                }).catch(err => {
                    this.loading = false;
                })
            },
            // 保存储值配置
            handleSubmit() {
                if(this.loading) {
                    return false;
                }
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.loading = true;
                        this.$api.totalPlatform.storedConfig({
                            body: {
                                ...values
                            }
                        }).then(res => {
                            this.$message.success('操作成功');
                            this.loading = false;
                        }).catch(err => {
                            this.loading = false;
                        })
                    }
                })
            }
        },
        created() {
        },
        mounted() {
            this.getStoredConfigDetail()
        }
    };
</script>
<style lang="scss">
.stored-value-config {
    .block-title {
        margin: 16px 0;
        font-size: 16px;
        line-height: 32px;
        font-weight: 900;
        color: rgba(0, 0, 0, 0.85);
    }
    .line {
        border-top: 1px solid #e8e8e8;
        margin-top: 16px;
    }
    .activity {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        >div {
            min-width: 422px;
            margin: 0 32px 32px 0;
            width: calc(50% - 32px);
            min-height: 450px;
            border-radius: 4px;
        }

        &-block {
            padding-bottom: 48px;
            border: 1px solid rgba(217,217,217,1);
            position: relative;
            background-color: #fff;

            .avatar-uploader {
                width: 97%;
                margin: 8px;
            }
            .ant-upload {
                height: 260px;
                width: 100%;
            }

            &-bottom {
                position: absolute;
                bottom: 1px;
                left: 0;
                width: 100%;
                height: 40px;
                line-height: 40px;
                text-align: center;
                border-top: 1px solid rgba(217,217,217,1);
                background: rgba(250,250,250,1);
                cursor: pointer;
            }
        }

        &-new {
            height: 464px;
            background: rgba(250,250,250,1);
            border-radius: 4px;
            border: 1px dotted rgba(217,217,217,1);
            text-align: center;
            padding-top: 180px;
            font-size: 24px;
            cursor: pointer;
        }
    }
}
</style>
